import { render, staticRenderFns } from "./InboxTable.vue?vue&type=template&id=25cbea4e&scoped=true&"
import script from "./InboxTable.vue?vue&type=script&lang=js&"
export * from "./InboxTable.vue?vue&type=script&lang=js&"
import style0 from "./InboxTable.vue?vue&type=style&index=0&id=25cbea4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cbea4e",
  null
  
)

export default component.exports